import {
  SubscriptionCancellationReasonResource,
  subscriptionCancellationReasonResourceSchema,
} from "@client/resources/SubscriptionCancellationReasonResource";
import { APIMethods, ApiResponse } from "@typeDefinitions";
import { fetchData } from "@utils/api";
import { logFetchValidateError } from "@utils/validate";
import { array, object } from "yup";

export type FetchSubscriptionCancellationReasonsResponse = ApiResponse<
  SubscriptionCancellationReasonResource[]
>;

const fetchSubscriptionCancellationReasonsSchema = object({
  data: array().of(subscriptionCancellationReasonResourceSchema).required(),
});

export const fetchSubscriptionCancellationReasons =
  async (): Promise<FetchSubscriptionCancellationReasonsResponse> => {
    const response = await fetchData(
      "/dietitian/subscription/cancellation-reasons",
      APIMethods.GET,
    );

    return await fetchSubscriptionCancellationReasonsSchema
      .validate(response)
      .catch(
        logFetchValidateError("/dietitian/subscription/cancellation-reasons"),
      );
  };
